import React from 'react';

import { BsCheckLg, BsXLg } from 'react-icons/bs';
import { FaPencilAlt } from 'react-icons/fa';
import { Stack } from 'react-bootstrap';

import Button from 'components/elements/SVButton';

interface Survey {
  id?: number;
  name?: string;
}

interface SurveyNameEditorProps {
  survey: Survey;
  editingId?: number;
  setEditingId: (id: number | null) => void;
  onUpdateSurveyName: (survey: { surveyId?: number; name: string }) => void;
}

const SurveyNameEditor: React.FC<SurveyNameEditorProps> = ({
  survey,
  editingId,
  setEditingId,
  onUpdateSurveyName,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  return editingId === survey.id ? (
    <Stack direction="horizontal" gap={2} className="align-items-center w-100">
      <input
        ref={inputRef}
        defaultValue={survey.name}
        style={{ flex: 1, minWidth: 0 }}
        type="text"
        onClick={(e) => e.stopPropagation()}
      />
      <Button
        variant="danger"
        size="sm"
        className="flex-shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          setEditingId(null);
        }}
      >
        <BsXLg />
      </Button>
      <Button
        variant="success"
        size="sm"
        className="flex-shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          if (inputRef.current) {
            onUpdateSurveyName({
              surveyId: survey.id,
              name: inputRef.current.value,
            });
          }
        }}
      >
        <BsCheckLg />
      </Button>
    </Stack>
  ) : (
    <Stack direction="horizontal" gap={2} className="align-items-center w-100">
      <span className="text-truncate">{survey.name}</span>
      <Button
        size="sm"
        variant="link"
        className="p-0 flex-shrink-0 ms-auto"
        onClick={(e) => {
          e.stopPropagation();
          setEditingId(survey.id ?? null);
        }}
      >
        <FaPencilAlt size={16} />
      </Button>
    </Stack>
  );
};

export default SurveyNameEditor;
